import {Brick, registerBrick, Service} from 'olympe';
import {SHARED_MEMORY_TOPICS} from '../../../services/service_api/CreateAllRASharedMemory.brick';

/**
 * This brick is responsible for setting cXML buyer cookies and user IDs into a shared memory.
 */
export default class SetInCXMLTimeoutMap extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} buyerCookieId
     * @param {string} buyerCookie
     * @param {function()} forwardEvent
     */
    update($, [buyerCookieId, buyerCookie], [forwardEvent]) {
        Service.publish('allRaSharedMemory', {topic: SHARED_MEMORY_TOPICS.CXML_BUYER_COOKIE, buyerCookieId, buyerCookie})
            .then(forwardEvent);
    }
}

registerBrick('0197c1419fdcbd10b195', SetInCXMLTimeoutMap);
